import React, { useEffect, useRef, useState } from "react";
import basestyle from "../Base.module.css";
import "../Login-otp/index.css";
import loginstyle from "../Login-otp/Login.module.css";
import Loader from "../../Components/Loader";
import GeneralToast from "../../Components/Toaster";
import {
  getStorageItem,
  setStorageItem,
  clearStorage,
} from "../../Utils/storage";
import { useNavigate } from "react-router-dom";
import { notifyError } from "../../Utils/toastify";
import { useVerifyEmailOtp } from "../../API/Queries/useVerifyOtp";
import { useTriggerEmailOtp } from "../../API/Queries/useTriggerEmailOtp";
import { useFetchUserRoles } from "../../API/Queries/useFetchUserRoles";
import { ROUTES } from "Utils/routes";

const OtpVerify = () => {
  const [otp, setOtp] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const email = getStorageItem("email");
  const [counter, setCounter] = useState(40);
  const navigate = useNavigate();
  const {
    data: triggerOtpData,
    isLoading: triggerEmailOtpLoading,
    error: triggerOtpError,
    mutate: triggerOtp,
  } = useTriggerEmailOtp();
  const {
    data: verifyOtpData,
    isLoading: verifyOtpLoading,
    error: verifyOtpError,
    mutate: verifyOtp,
  } = useVerifyEmailOtp();

  const { isLoading: rolesLoading, mutateAsync: fetchUserRoles } =
    useFetchUserRoles();

  // need to get privilages from all roles and privilages from data
  const fetchRole = async (id) => {
    const res = await fetchUserRoles(id);
    if (res) {
      const { roles, privileges } = res?.data || {};

      const innerPrivilegeMap = new Map();

      //flat privileges from all roles and push to innerPrivilegesMap
      roles.forEach((role) => {
        role.privileges.forEach((priv) => {
          innerPrivilegeMap.set(priv.name, priv);
        });
      });

      //if outer privileges has grantType = ALLOWED then add to innerPrivilegesMap, else remove that from innerPrivilegesMap -> if it has same privilege name
      privileges.forEach(({ privilege, grantType }) => {
        if (grantType === "ALLOWED") {
          innerPrivilegeMap.set(privilege.name, privilege);
        } else if (innerPrivilegeMap.has(privilege.name)) {
          innerPrivilegeMap.delete(privilege.name);
        }
      });

      const privilegeNames = Array.from(innerPrivilegeMap.values()).map(
        (p) => p.name
      );

      setStorageItem("privileges", privilegeNames);

      if (!privilegeNames.length) {
        notifyError("Login failed. You do not have access!");
        setErrorMessage("Login failed. You do not have access!");
        clearStorage();
        navigate(ROUTES.LOGIN_EMAIL);
      } else {
        navigate(ROUTES.START);
      }
    }
  };

  const fetchRoleRef = useRef(fetchRole);
  fetchRoleRef.current = fetchRole;
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  useEffect(() => {
    const fetchRole = fetchRoleRef.current;
    const navigate = navigateRef.current;
    if (verifyOtpData && verifyOtpData?.data?.data) {
      let ownerData = verifyOtpData?.data?.data?.realms?.find(
        (m) => m.role === "OWNER"
      );
      if (!ownerData) {
        ownerData = verifyOtpData?.data?.data?.realms[0];
      }
      const { realmName, systemUserId, realmIdentifier, contactNumber } =
        ownerData || {};

      const authData = {
        ...verifyOtpData?.data?.data,
        realmIdentifier,
        contactNumber,
        systemUserId,
        realmName,
      };

      setStorageItem("authData", authData);
      setStorageItem("ownerData", ownerData);

      if (ownerData?.role !== "SYSTEM") {
        fetchRole(ownerData?.asgardUserId);
      } else {
        notifyError("Login failed. You are not owner!");
        clearStorage();
        navigate(ROUTES.LOGIN_EMAIL);
      }
    }
    if (verifyOtpError) {
      setErrorMessage(
        verifyOtpError?.response?.data?.data?.message ||
          verifyOtpError?.response?.data?.errorMessage ||
          verifyOtpError?.message ||
          "Something went wrong"
      );
    }
  }, [verifyOtpData, verifyOtpError]);

  const onOTPSubmit = () => {
    setErrorMessage("");
    const payload = {
      input: {
        otp: otp,
        identity: email,
      },
    };
    verifyOtp(payload);
  };

  const handleResendOtp = () => {
    setErrorMessage("");
    const payload = {
      input: {
        identity: email,
        resend: true,
      },
    };
    triggerOtp(payload);
  };

  useEffect(() => {
    if (triggerOtpData && triggerOtpData?.data?.status === 200) {
      setCounter(40);
    }
    if (triggerOtpError) {
      setErrorMessage(
        triggerOtpError?.response?.data?.errorMessage ||
          triggerOtpError?.message ||
          "Something went wrong"
      );
    }
  }, [triggerOtpData, triggerOtpError]);

  useEffect(() => {
    if (counter <= 0) {
      setCounter(0);
      return undefined;
    }
    const timeOut = setTimeout(() => {
      setCounter(counter - 1);
    }, 1000);
    return () => clearTimeout(timeOut);
  }, [counter]);

  return (
    <>
      {(triggerEmailOtpLoading || verifyOtpLoading || rolesLoading) && (
        <Loader />
      )}
      <div className={loginstyle.parentContainer}>
        <div className={loginstyle.login}>
          <p className="text-xl font-semibold mt-2 mb-4">
            Enter Verification Code
          </p>
          <p className="flex items-start font-semibold mb-2">
            OTP send to {email}
          </p>

          <div className="input-container">
            <input
              type="number"
              name="otp"
              value={otp}
              placeholder="Enter OTP"
              className="input_custom"
              onChange={(e) => {
                const value = e.target.value.slice(0, 6);
                setOtp(value);
              }}
            />
          </div>

          <div className="my-4">
            <button
              type="button"
              className={`${counter === 0 ? "underline" : ""} border-0 bg-transparent p-0`}
              disabled={counter !== 0}
              onClick={handleResendOtp}
            >
              Resend OTP
            </button>{" "}
            - {counter || "00"} sec
          </div>

          <button
            type="submit"
            onClick={onOTPSubmit}
            className={basestyle.button_common}
            style={{ opacity: otp?.length !== 6 ? 0.5 : 1 }}
            disabled={otp?.length !== 6}
          >
            {verifyOtpLoading ? "Loading..." : "Verify OTP"}
          </button>
        </div>
      </div>
      {errorMessage && <GeneralToast type="error" message={errorMessage} />}
    </>
  );
};

export default OtpVerify;
